import * as React from 'react';
import { useSelector } from 'react-redux';

import { selectIsOfferPageRedesign } from 'shared/selectors';

import { NewbuildingBuildersFactItem, NewbuildingBuildersFacts } from '../../components/NewbuildingBuildersFacts';
import { selectBuilderFacts, selectIsNewbuildingPremiumRate } from '../../selectors/newbuildingPremiumRate';

export function NewbuildingBuildersFactsContainer() {
  const isEnabled = useSelector(selectIsNewbuildingPremiumRate);
  const facts = useSelector(selectBuilderFacts);
  const isRedesigned = useSelector(selectIsOfferPageRedesign);

  if (!facts || !isEnabled) {
    return null;
  }

  return (
    <NewbuildingBuildersFacts>
      {facts.map(item => (
        <NewbuildingBuildersFactItem
          v2={isRedesigned}
          key={item.title}
          imageUrl={item.imageUrl}
          title={item.title}
          description={item.description}
        />
      ))}
    </NewbuildingBuildersFacts>
  );
}
